export enum SystemEventType {
  COMMON = 'COMMON',
  LETTER_STATUS_CHANGE = 'LETTER_STATUS_CHANGE',
  LETTER_DEPARTMENT_CHANGE = 'LETTER_DEPARTMENT_CHANGE',
  BALANCE_INCOME = 'BALANCE_INCOME',
}
